import { FaStar } from "react-icons/fa";

interface BestBadgeProps {
  rank: number;
}

export const BestBadge = ({ rank }: BestBadgeProps) => {
  return (
    <div className="absolute top-0 left-0 bg-primary-400/80 text-white rounded-br-md px-1.5 py-0.5 text-[10px] font-medium flex items-center gap-0.5 backdrop-blur-sm z-50">
      <FaStar className="w-2.5 h-2.5" />
      <span>{rank}</span>
    </div>
  );
}; 